<template>
  <div ref="mapContainer" class="map-container">
    <!-- 底图切换 -->
    <!-- <changeLayer :selectLayer="currentLayer" @changeLayer="handleChangeLayer" /> -->

    <!-- 操作按钮 -->
    <!-- <div class="operation-list">
      <div v-for="item in opeList" :key="item.key" class="ope-each" :style="{
        borderBottom:
          item.key !== 'Homepage'
            ? '1px solid lightskyblue'
            : ''
      }" @click="handleClick(item.key)">
        <SvgIcon :name="item.iconName" width="100%" height="100%" color="#000000" />
      </div>
    </div> -->
  </div>
</template>

<script>
import Map from 'ol/Map';
import View from 'ol/View';
import Point from 'ol/geom/Point';
import { Feature } from 'ol';

import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import { transform, fromLonLat } from 'ol/proj';

import {
  Style,
  Icon,
  Text,
  Fill,
  Stroke
} from 'ol/style';

import { defaults as defaultsControls } from 'ol/control';

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';

import coordtransform from 'coordtransform';

// import changeLayer from './changeLayer.vue';
// import SvgIcon from '@/components/PageCommon/svgIcon.vue';

import { BaseLayerManager } from './baseLayerManager.js';

import HomeLocate from '@/assets/icons/locate_home.svg';

import NormalLocate from '@/assets/icons/locate_normal.svg';
import { Circle } from 'ol/geom.js';

// 注册 GCJ-02
proj4.defs('GCJ-02', '+proj=longlat +datum=GCJ-02 +no_defs');
register(proj4);

const defaultZoomLevel = 16;
const defaultCenter = [120.873998, 31.239495];

export default {
  name: 'OlMap',
  props: {
    centerPoint: {
      type: Object,
      default: () => {
        return defaultCenter;
      }
    },
    zoom: {
      type: Number,
      default: () => {
        return defaultZoomLevel;
      }
    },
  },
  watch: {
    centerPoint: {
      handler(val) {
        if (val?.lat && val.lng) {
          if (!this.ol_view) {
            this.pendingCenter = [val.lng, val.lat]
          } else {
            this.flyToCenter([val.lng, val.lat]);
            this.addPoints([{ location: [val.lng, val.lat], iconUrl: NormalLocate, scale: 0.3 }])
          }
          // this.addPointAndSize()
        } else {
          this.flyToCenter([120.873998, 31.239495]);
          this.addPoints([
            {
              location: [120.873998, 31.239495],
              text: '至善',
              iconUrl: HomeLocate,
              scale: 0.3
            }
          ]);
        }
      },
      deep: true,
      immediate: true
    },
  },

  // components: {
  //   // changeLayer,
  //   // SvgIcon
  // },

  data() {
    return {
      currentLayer: 'gdVector',

      opeList: [
        { iconName: 'add', title: '放大', key: 'Add' },
        { iconName: 'reduce', title: '缩小', key: 'Reduce' },
        { iconName: 'homepage', title: '中心点', key: 'Homepage' }
      ],

      ol_map: null,
      ol_view: null,
      baseLayerManager: null,

      vectorSource: new VectorSource(),

      vectorLayer: null
    };
  },

  mounted() {
    this.initMap();

    setTimeout(() => {
      this.addPoints([
        {
          location: [120.873998, 31.239495],
          text: '至善',
          iconUrl: HomeLocate,
          scale: 0.3
        }
      ]);
    }, 100);
  },

  methods: {
    initMap() {
      this.vectorLayer = new VectorLayer({
        source: this.vectorSource,
        zIndex: 100
      });

      this.ol_view = new View({
        center: this.gcj02To3857(defaultCenter),
        zoom: defaultZoomLevel
      });

      this.ol_map = new Map({
        target: this.$refs.mapContainer,
        view: this.ol_view,
        controls: defaultsControls({
          zoom: false,
          rotate: false,
          attribution: false
        })
      });

      this.ol_map.addLayer(this.vectorLayer);

      this.baseLayerManager = new BaseLayerManager(this.ol_map, [
        {
          name: 'gdVector',
          url:
            'https://webrd04.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}',
          visible: true
        },
        {
          name: 'gdSatellite',
          url:
            'https://webst01.is.autonavi.com/appmaptile?style=6&x={x}&y={y}&z={z}',
          visible: false
        },
        {
          name: 'gdRoad',
          url:
            'https://stamen-tiles.a.ssl.fastly.net/terrain/{z}/{x}/{y}.png',
          visible: false
        },
        {
          name: 'dark',
          url:
            'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}@2x.png',
          visible: false
        }
      ]);

      if (this.pendingCenter) {
        this.flyToCenter(this.pendingCenter);
        this.addPoints([{ location: this.pendingCenter, iconUrl: NormalLocate, scale: 0.3 }])
      }
    },

    // gcj02 => wgs84 => ol坐标
    transformGCJ02(location) {
      const wgs84 = coordtransform.gcj02towgs84(
        location[0],
        location[1]
      );

      return fromLonLat([
        wgs84[0],
        wgs84[1]
      ]);
    },

    // GCJ-02 => EPSG:3857
    gcj02To3857(location) {
      return transform(
        location,
        'EPSG:4326',
        'EPSG:3857'
      );
    },

    // 回到中心点
    flyToCenter(
      location = defaultCenter,
      zoomLevel = defaultZoomLevel,
      duration = 1500
    ) {
      if (!this.ol_view) return;
      const currentZoom =
        this.ol_view.getZoom() || zoomLevel;

      this.ol_view.animate(
        {
          center: this.gcj02To3857(location),
          duration
        },
        {
          zoom: currentZoom,
          duration
        }
      );
    },

    // 放大
    zoomIn() {
      if (!this.ol_view) return;

      const currentZoom =
        this.ol_view.getZoom() || defaultZoomLevel;

      this.ol_view.animate({
        zoom: currentZoom + 1,
        duration: 1000
      });
    },

    // 缩小
    zoomOut() {
      if (!this.ol_view) return;

      const currentZoom =
        this.ol_view.getZoom() || defaultZoomLevel;

      this.ol_view.animate({
        zoom: currentZoom - 1,
        duration: 1000
      });
    },

    // 添加点位以及文字
    addPointAndSize(location, text) {
      if (!this.ol_map) return;

      const marker = new Feature({
        geometry: new Point(fromLonLat(location))
      });

      const iconStyle = new Style({
        image: new Icon({
          anchor: [0.5, 1],
          src: NormalLocate,
          scale: 1
        }),
        zIndex: 10
      });

      const textStyle = new Style({
        text: new Text({
          text,
          font: '14px sans-serif',
          fill: new Fill({
            color: '#000'
          }),
          stroke: new Stroke({
            color: '#fff',
            width: 2
          }),
          offsetY: -20,
          offsetX: -10
        }),
        zIndex: 20
      });

      marker.setStyle([iconStyle, textStyle]);

      const vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [marker]
        }),
        zIndex: 5
      });

      this.ol_map.addLayer(vectorLayer);
    },

    // 批量添加点位
    addPoints(points) {
      if (!this.ol_map) return;

      const features = points.map(item => {
        const marker = new Feature({
          geometry: new Point(
            this.gcj02To3857(item.location)
          )
        });

        // 图标样式
        const iconStyle = new Style({
          image: new Icon({
            anchor: [0.5, 1],
            src:
              item.iconUrl ||
              'https://cdn.jsdelivr.net/gh/openlayers/openlayers.github.io@master/en/v6.5.0/examples/data/icon.png',
            scale: item.scale || 1
          }),
          zIndex: 10
        });

        // 文字样式
        const textStyle = new Style({
          text: new Text({
            text: item.text,
            font: '14px sans-serif',
            fill: new Fill({
              color: item.textColor || '#1296db'
            }),
            stroke: new Stroke({
              color: '#fff',
              width: 2
            }),
            offsetX: 0,
            offsetY: 10
          }),
          zIndex: 20
        });

        marker.setStyle([
          iconStyle,
          textStyle
        ]);

        return marker;
      });

      this.vectorSource.addFeatures(features);
    },

    handleClick(key) {
      switch (key) {
        case 'Homepage':
          this.flyToCenter();
          break;

        case 'Add':
          this.zoomIn();
          break;

        case 'Reduce':
          this.zoomOut();
          break;
      }
    },

    // 修改图层
    handleChangeLayer(key) {
      if (!this.baseLayerManager) return;

      this.baseLayerManager.switchLayer(key);
      this.currentLayer = key;
    }
  }
};
</script>

<style scoped>
.map-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.operation-list {
  position: absolute;
  right: 40px;
  bottom: 60px;
  z-index: 1000;
  display: flex;
  flex-wrap: wrap;
  width: 40px;
  background: #ffffff;
  border: 1px solid lightskyblue;
  opacity: 0.6;
}

.operation-list .ope-each {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid lightskyblue;
}
</style>